import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import {
  useParams,
} from "react-router-dom";

import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
} from "react-leaflet";

import L from "leaflet";

import "leaflet/dist/leaflet.css";


// ======================================================
// FIX LEAFLET MARKER ICON
// ======================================================

const liveIcon =
  new L.Icon({
    iconUrl:
      "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",

    shadowUrl:
      "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",

    iconSize: [
      25,
      41,
    ],

    iconAnchor: [
      12,
      41,
    ],

    popupAnchor: [
      1,
      -34,
    ],

    shadowSize: [
      41,
      41,
    ],
  });


// ======================================================
// LIVE LOCATION VIEWER
// ======================================================

export default function LiveLocationViewer() {

  const {
    sessionId,
  } =
    useParams();

  const [
    location,
    setLocation,
  ] =
    useState(null);

  const [
    loading,
    setLoading,
  ] =
    useState(true);

  const [
    error,
    setError,
  ] =
    useState("");

  const mapRef =
    useRef(null);


  // ====================================================
  // FETCH LOCATION
  // ====================================================

  const fetchLocation =
    async () => {

      try {

        const response =
          await fetch(
            `https://vedai.vemeet.online/api/live-location/${sessionId}`
          );

        const data =
          await response.json();

        if (
          !response.ok ||
          !data.success
        ) {

          throw new Error(
            data.message ||
            "Live location unavailable"
          );

        }

        setLocation(
          data.location
        );

        setError("");

        setLoading(false);

      }

      catch (
        fetchError
      ) {

        console.error(
          "LIVE LOCATION VIEWER ERROR:",
          fetchError
        );

        setError(
          fetchError.message ||
          "Unable to load live location"
        );

        setLoading(false);

      }

    };


  // ====================================================
  // POLLING
  // ====================================================

  useEffect(
    () => {

      if (
        !sessionId
      ) {

        setError(
          "Invalid live location link"
        );

        setLoading(false);

        return;

      }

      fetchLocation();

      const interval =
        setInterval(
          fetchLocation,
          3000
        );

      return () => {

        clearInterval(
          interval
        );

      };

    },
    [
      sessionId,
    ]
  );


  // ====================================================
  // LOADING
  // ====================================================

  if (
    loading
  ) {

    return (

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#111",
          color: "#fff",
          fontSize: "20px",
        }}
      >

        Loading live location...

      </div>

    );

  }


  // ====================================================
  // ERROR
  // ====================================================

  if (
    error
  ) {

    return (

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#111",
          color: "#fff",
          padding: "30px",
          textAlign: "center",
        }}
      >

        <div>

          <h2>
            Live Location Unavailable
          </h2>

          <p>
            {error}
          </p>

        </div>

      </div>

    );

  }


  // ====================================================
  // WAITING FOR GPS
  // ====================================================

  if (
    !location ||
    typeof location.latitude !== "number" ||
    typeof location.longitude !== "number"
  ) {

    return (

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#111",
          color: "#fff",
          padding: "30px",
          textAlign: "center",
        }}
      >

        <div>

          <h2>
            Waiting for live location...
          </h2>

          <p>
            The phone has not sent a GPS position yet.
          </p>

        </div>

      </div>

    );

  }


  const position = [
    location.latitude,
    location.longitude,
  ];


  return (

    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "relative",
      }}
    >

      <MapContainer
        center={position}
        zoom={16}
        style={{
          width: "100%",
          height: "100%",
        }}
        ref={mapRef}
      >

        <TileLayer
          attribution="&copy; OpenStreetMap contributors"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        <Marker
          position={position}
          icon={liveIcon}
        >

          <Popup>

            Live Location

          </Popup>

        </Marker>

      </MapContainer>


      {/* ============================================= */}
      {/* TOP STATUS BAR */}
      {/* ============================================= */}

      <div
        style={{
          position: "absolute",
          top: "20px",
          left: "20px",
          right: "20px",
          zIndex: 1000,
          background: "rgba(0,0,0,0.8)",
          color: "#fff",
          padding: "14px",
          borderRadius: "12px",
          fontSize: "16px",
        }}
      >

        <strong>
          🔴 Live Location
        </strong>

        <br />

        Updated continuously

      </div>

    </div>

  );

}